import React from "react";

class SelectLocations extends React.Component {
  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }
  onSubmit(e) {
    e.preventDefault();
    this.props.changeView('init_menu');
  }
  render() {
    return (
      <div className="main-container-loyalty">
        <h3 className="base-heading">SET YOUR LOYALTY PROGRAM</h3>
        <p className="sub-heading">
         Select locations where you want to run your loyalty program
        </p>
        <div className="loyalty-menu-options-child">
          <img
            className="loyalty-menu-options-child-image"
            src="/amountSpent.svg"
          />
          <p className="loyalty-menu-heading">Earn points by Amount</p>
        </div>

        <div className="loyalty-menu-form">
          <form onSubmit={this.onSubmit}>
            <div className="loyalty-menu-form-field">
              <p>Add Location</p>
              <div className="loyalty-menu-form-custom-div">
                Location 1
                <input
                  type="checkbox"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>
            <div className="loyalty-menu-form-field">
              {/* <p>Add Location</p> */}
              <div className="loyalty-menu-form-custom-div">
                Location 2
                <input
                  type="checkbox"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>{" "}
            <div className="loyalty-menu-form-field">
              {/* <p>Add Location</p> */}
              <div className="loyalty-menu-form-custom-div">
                Location 3
                <input
                  type="checkbox"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>{" "}
            <div className="loyalty-menu-form-field">
              {/* <p>Add Location</p> */}
              <div className="loyalty-menu-form-custom-div">
                Location 4
                <input
                  type="checkbox"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>
            <div className="loyalty-menu-form-button-container">
              <button type="submit" className="loyalty-menu-form-button">
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default SelectLocations;



// WEBPACK FOOTER //
// ./src/containers/LoyaltySetup/SelectionLocations.js